export default {
  en: {
    SELECT_CAMPAIGN_LABEL: 'Campaign',
    SELECT_CAMPAIGN_TT: 'Block the caller on this campaign',
    SELECT_CAMPAIGN_PLACEHOLDER: 'Select Campaign',
    UPDATE_BTN: 'Update Settings',
  }
};